import 'Src/less/automotive/tires-landing-page.less';
import TireFitmentLookup from './components/TireFitmentLookup.vue';
import TireSizeLookupService from './services/TireSizeLookupService';
import Vue from 'vue';
import { BlogCategories, BlogTagGroups } from 'JS/services/BlogService';
import { CustomerVehicleService } from 'JS/services/automotive/CustomerVehicleService';
import { initializeBlogCarousel } from 'Src/js/utilities/blog';
import { initializeChangeStoreButton } from '../shared/utils/store';
import { lazyLoadImages } from 'JS/global/images';

const vehicleForm = document.getElementById('tlpFitmentVue');
if (vehicleForm) {
	new Vue({
		el: vehicleForm,
		render: h => h(TireFitmentLookup),
		provide: {
			CustomerVehicleService: new CustomerVehicleService(),
			TireSizeLookupService: new TireSizeLookupService()
		}
	});
}

initializeChangeStoreButton('.alp-store__change', 'auto');

initializeBlogCarousel('#tlpBlogCarousel', {
	title: 'Tire Care Tips & Advice',
	viewAllLink: 'https://www.farmandfleet.com/blog/tag/tires/',
	viewAllLinkAssistiveText: 'Tire Related Blog Posts',
	query: {
		categories: [BlogCategories.Automotive],
		tags: BlogTagGroups.Tires,
		perPage: 12,
	},
});

lazyLoadImages(document.querySelector('#tlp') as HTMLElement);